module.exports = __webpack_public_path__ + "media/flags/dk-54a9d51d.svg";